import React, { useState } from 'react';
import { commonStyles, colors, layout, typography } from '../styles/minimalStyles';
import AnimateOnScroll from '../../Components/AnimateOnScroll';
const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  // State to track hover state for *each* tag separately
  const [hoveredTag, setHoveredTag] = useState(null);

  if (!categories || categories.length <= 1) {
    return null;
  }

  const styles = {
    filterSection: {
      ...commonStyles.container,
      ...commonStyles.section,
      backgroundColor: colors.backgroundLight,
      padding: '20px', // Add padding inside the section
      borderRadius: '8px',
      border: `1px solid ${colors.border}`,
    },
    filterTitle: {
      fontSize: '1.1rem',
      fontWeight: typography.boldWeight,
      margin: '0 0 15px 0',
      color: colors.primaryText,
    },
    filterTags: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
    },
    tagBase: {
      padding: '8px 15px',
      borderRadius: '20px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease',
      fontSize: '0.9rem',
      fontWeight: '500',
      backgroundColor: colors.white,
      color: '#555',
      border: `1px solid #ccc`,
      fontFamily: typography.fontFamily,
    },
    tagHover: { // Style applied when hoveredTag matches category
       backgroundColor: '#e9ecef',
       borderColor: '#bbb',
    },
    tagActive: { // Style applied when selectedCategory matches category
      backgroundColor: colors.accent,
      color: colors.white,
      borderColor: colors.accent,
      fontWeight: typography.boldWeight,
    },
    tagActiveHover: { // Style applied when active AND hovered
       backgroundColor: colors.accentDark,
       borderColor: colors.accentDark,
    }
  };


  return (
     <AnimateOnScroll> 
      <section style={styles.filterSection}>
        <h3 style={styles.filterTitle}>Filter by Category</h3>
        <div style={styles.filterTags}>
          {categories.map((category) => {
            const isActive = selectedCategory === category;
            const isHovered = hoveredTag === category;

            // Determine the final style based on active and hover states
            let currentStyle = {...styles.tagBase};
            if (isActive) {
              currentStyle = {...currentStyle, ...styles.tagActive};
            }
            if (isHovered) {
               if (isActive) {
                  currentStyle = {...currentStyle, ...styles.tagActiveHover};
               } else {
                   currentStyle = {...currentStyle, ...styles.tagHover};
               }
            }


            return (
              <button
                key={category}
                style={currentStyle}
                onClick={() => onSelectCategory(category)}
                onMouseEnter={() => setHoveredTag(category)}
                onMouseLeave={() => setHoveredTag(null)}
                aria-pressed={isActive}
              >
                {category}
              </button>
            );
          })}
        </div>
      </section>
    </AnimateOnScroll>
  );
};

export default CategoryFilter;